/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import EmailConfirmationRepository from 'repositories/auth/EmailConfirmationRepository';

const initialState = {
  emailConfirmationResendingStatus: FETCH_STATUSES.idle,
};

const authEmailConfirmationSlice = createSlice({
  name: 'authEmailConfirmationSlice',
  initialState,
  reducers: {
    resendEmailConfirmationStart(state) {
      state.emailConfirmationResendingStatus = FETCH_STATUSES.pending;
    },
    resendEmailConfirmationSuccess(state) {
      state.emailConfirmationResendingStatus = FETCH_STATUSES.fulfilled;
    },
    resendEmailConfirmationFail(state) {
      state.emailConfirmationResendingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = authEmailConfirmationSlice;

export default authEmailConfirmationSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const resendEmailConfirmation = async () => {
    dispatch(actions.resendEmailConfirmationStart());
    try {
      await EmailConfirmationRepository.resend();
      dispatch(actions.resendEmailConfirmationSuccess());
    } finally {
      dispatch(actions.resendEmailConfirmationFail());
    }
  };

  return {
    resendEmailConfirmation,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/auth/emailConfirmationSlice.js